export default __webpack_public_path__ + "static/media/Stats_Duration.9a0025be.svg";